import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom/cjs/react-router-dom";

import copyIcon from "../../../../assets/icons/copy-icon.svg";
import { convertDateToUTC } from "../../../../shared/utility";
import ProfileImage from "../../../../shared/components/ProfileImage/ProfileImage";
import { customerDashboardActions } from "../../../../redux/actions/customerDashboard.actions";

const AttendedEventsTab = (props) => {
  const { searchResult, recentSearches } = { ...props };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const formProps = Object.fromEntries(formData);
    
    let updatedEventId = formProps.eventId;

    // Backward compatibility for old eventId format
    if (updatedEventId && !updatedEventId.includes("-")) {
      updatedEventId = `${updatedEventId}-1`;
    }
    
    props.getSearchResult(updatedEventId, props.userId);
  };

  const handleSearch = (prevEventId) => {
    props.getSearchResult(prevEventId, props.userId);
  };

  useEffect(() => {
    props.getRecentSearches(props.userId);

    return () => {
      props.resetAttendedEvent();
    };
    // eslint-disable-next-line
  }, []);

  const copyToClipboard = async (e) => {
    const eventUrl = `${window.location.protocol}//${window.location.host}/SharedGallery?eventid=${searchResult?.id}`;
    e.preventDefault();
    await navigator.clipboard.writeText(eventUrl);
    alert("Link Copied");
  };

  return (
    <div className="container attended-events-tab py-3">
      <div className="row">
        <div className="col px-0">
          <h5 className="p-0 m-0 mb-2">attending event</h5>
          <p className="p-0 m-0 mb-3">
            if you are a guest at an event with a shutterb, please enter the
            event ID below to access the event images.
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col px-0">
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="mb-1">
              <label htmlFor="eventId">enter event id:</label>
            </div>
            <input
              type="search"
              name="eventId"
              placeholder="enter event id"
              minLength={3}
              maxLength={30}
              required
            />
            <button className="btn-simple mb-4" type="submit">
              SEARCH
            </button>
          </form>

          {searchResult?.id && (
            <div className="row py-3 px-3 search-result">
              <div className="col px-0">
                {/* Details grid (labels left, values left-aligned in right column) */}
                <div className="details-grid">
                  <div className="label">event name:</div>
                  <div className="value">{searchResult?.eventName}</div>

                  <div className="label">event id:</div>
                  <div className="value">{searchResult?.id}</div>

                  <div className="label">uploaded on:</div>
                  <div className="value">
                    {convertDateToUTC(
                      searchResult?.eventDate,
                      searchResult?.eventLocations?.[0]?.timezone
                    )}
                  </div>
                  <div className="label">uploaded by:</div>
                </div>

                <div className="shutterb-uploader-list">
                  {searchResult?.orderItems?.map((sb) => (
                    <div className="shutterb-uploader" key={sb?.id}>
                      <span className="shutterb-profile-image">
                        <ProfileImage
                          imageUrl={
                            sb?.sbUser?.sbPortfolios[0]?.profileImageUrl
                          }
                        />
                      </span>
                      <div className="shutterb-profile-name">
                        {sb?.sbUser?.sbPortfolios[0]?.profileName}
                      </div>
                    </div>
                  ))}
                </div>

                {/* View Gallery (bottom-left) */}
                <Link
                  className="btn-simple view-event-btn mt-4"
                  to={`/SharedGallery?eventid=${searchResult?.id}`}
                >
                  View Gallery
                </Link>

                {/* Copy icon (bottom-right) */}
                <div className="shared-icon-con" onClick={copyToClipboard}>
                  <img src={copyIcon} alt="" className="cursor-pointer" />
                </div>
              </div>
            </div>
          )}

          <div className="row recent-search-list">
            <div className="col-12 p-0">
              <h5>recent search</h5>
              {recentSearches?.map((item, index) => (
                <div key={index} className="row mb-2">
                  {/* Event ID */}
                  <div className="col-12 col-sm-4 col-md-3 event-id p-0">
                    event id:{" "}
                    <span
                      className="cursor-point text-primary"
                      onClick={() => handleSearch(item.eventId)}
                    >
                      <u className="text-underline">{item.eventId}</u>
                    </span>
                  </div>
                  {/* Event Name */}
                  <div className="col-12 col-sm-9 p-0">{item.eventName}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  userId: state.authentication.userId,
  searchResult: state.customerDashboard.attendedEvents.searchResult,
  recentSearches: state.customerDashboard.attendedEvents.recentSearches,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getRecentSearches: (userId) =>
    dispatch(customerDashboardActions.attendedEventRecentSearches(userId)),
  getSearchResult: (eventId, userId) =>
    dispatch(
      customerDashboardActions.attendedEventSearchResult(eventId, userId)
    ),
  resetAttendedEvent: () =>
    dispatch(customerDashboardActions.resetAttendedEvent()),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AttendedEventsTab));
